var HANDOUT_STATUSES, MINI_DS_PREFIX, deriveHandoutDocumentUrlFromTopicSlug, deriveHandoutIdFromTopicId;

MINI_DS_PREFIX = require('lib/doc_prefixes').miniDsDoc;

deriveHandoutIdFromTopicId = function(topicId) {
  if (!topicId) {
    return;
  }
  return "" + MINI_DS_PREFIX + (uuid.v5(topicId, uuid.NIL));
};

deriveHandoutDocumentUrlFromTopicSlug = function(topicSlug) {
  if (!topicSlug) {
    return;
  }
  return "" + topicSlug + "_handout";
};

HANDOUT_STATUSES = ['handoutSetup', 'handoutCreated', 'inReview', 'finalHandoutCheck', 'done', 'excluded'];

module.exports = {
  deriveHandoutDocumentUrlFromTopicSlug: deriveHandoutDocumentUrlFromTopicSlug,
  deriveHandoutIdFromTopicId: deriveHandoutIdFromTopicId,
  HANDOUT_STATUSES: HANDOUT_STATUSES
};
